// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__21V-L","question":"Question_question__gGTUw","description":"Question_description__3dnf3"};